import { render, staticRenderFns } from "./CallLogTypeEdit.vue?vue&type=template&id=3d16973f&scoped=true&"
import script from "./CallLogTypeEdit.vue?vue&type=script&lang=js&"
export * from "./CallLogTypeEdit.vue?vue&type=script&lang=js&"
import style0 from "./CallLogTypeEdit.vue?vue&type=style&index=0&id=3d16973f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d16973f",
  null
  
)

export default component.exports